import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { TranslationKey } from "../i18n/translations";
import styles from "./About.module.css";

export const About: React.FC = () => {
  const { t } = useLanguage();

  // Helper function to cast strings to TranslationKey
  const translate = (key: string): string => {
    return t(key as TranslationKey);
  };

  return (
    <div className={styles.about}>
      <div className={styles.hero}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>{translate("about.title")}</h1>
          <p className={styles.heroSubtitle}>{translate("about.subtitle")}</p>
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.section}>
          <div className={styles.sectionContent}>
            <h2 className={styles.sectionTitle}>{translate("about.story.title")}</h2>
            <p className={styles.sectionText}>{translate("about.story.text1")}</p>
            <p className={styles.sectionText}>{translate("about.story.text2")}</p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionContent}>
            <h2 className={styles.sectionTitle}>{translate("about.passion.title")}</h2>
            <p className={styles.sectionText}>{translate("about.passion.text1")}</p>
            <p className={styles.sectionText}>{translate("about.passion.text2")}</p>
            <p className={styles.sectionText}>{translate("about.passion.text3")}</p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionContent}>
            <h2 className={styles.sectionTitle}>{translate("about.mission.title")}</h2>
            <p className={styles.sectionText}>{translate("about.mission.text")}</p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionContent}>
            <h2 className={styles.sectionTitle}>{translate("about.approach.title")}</h2>
            <p className={styles.sectionText}>{translate("about.approach.text1")}</p>
            <p className={styles.sectionText}>{translate("about.approach.text2")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
